import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/administration/integrations/_webhooks/webhook/events')({
    beforeLoad: () => {
        throw redirect({ to: '/administration/integrations/webhook', replace: true })
    },
})
